import { IframePage } from '@app/pages/IframePage';

const BILLING_HOST = process.env.REACT_APP_BILLING_HOST || '';

interface OrganizationTariffsProps {
  organizationId: number;
}

export const OrganizationTariffs = ({
  organizationId,
}: OrganizationTariffsProps) => {
  return (
    <div className="tariffs-frame">
      <IframePage host={BILLING_HOST} organizationId={organizationId} />
    </div>
  );
};
